import { render, staticRenderFns } from "./QuestionnaireCard.vue?vue&type=template&id=6d890944&scoped=true"
import script from "./QuestionnaireCard.vue?vue&type=script&lang=js"
export * from "./QuestionnaireCard.vue?vue&type=script&lang=js"
import style0 from "./QuestionnaireCard.vue?vue&type=style&index=0&id=6d890944&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d890944",
  null
  
)

export default component.exports